import { Field } from 'formik';
import styled from 'styled-components';
import { inputStyles } from '../../../base/forms/input';

export const TextArea = styled(Field)`
	${inputStyles}
	margin: 1rem 0;
	height: 10rem;
	min-height: 10rem;
	padding: 1rem 2.5rem 0rem 2.5rem;
	resize: vertical;
	overflow: auto;
`;

export const FieldWrapper = styled.div`
	margin-bottom: 1rem;
`;
